(() => {
    const popup = document.getElementById('upgradeConfirmPopup');
    const overlay = document.getElementById('upgradePopupOverlay');
    const closeBtn = document.getElementById('upgradePopupClose');
    const cancelBtn = document.getElementById('upgradePopupCancel');
    const form = document.getElementById('upgradeConfirmForm');
    const successMsg = document.getElementById('upgradePopupSuccess');

    if (!popup || !overlay || !form) {
        return;
    }

    const noteEl = popup.querySelector('.diu-upgrade-popup__note');
    const noteTemplate = noteEl ? noteEl.textContent : '';
    const currentPlanTitle = popup.dataset.currentPlanTitle || '';

    const openPopup = () => {
        popup.classList.add('d-block');
        overlay.classList.add('d-block');
    };

    const closePopup = () => {
        popup.classList.remove('d-block');
        overlay.classList.remove('d-block');
        successMsg.classList.add('d-none');
        form.classList.remove('d-none');
        const submitBtn = form.querySelector('[type="submit"]');
        if (submitBtn) {
            submitBtn.disabled = false;
        }
    };

    const fillPlanData = (trigger) => {
        const targetPlanTitle = trigger.dataset.planTitle || '';

        const titleEl = document.getElementById('upgradePopupPlanTitle');
        if (titleEl) titleEl.textContent = targetPlanTitle;
        const priceEl = document.getElementById('upgradePopupPlanPrice');
        if (priceEl) priceEl.textContent = trigger.dataset.planPrice || '';

        // The per-package feature list is maintained in the Neos backend (Plan
        // "Beschreibung") and carried here via data-plan-description (trusted CMS
        // content, same source already rendered in the plan teaser).
        const featuresEl = document.getElementById('upgradePopupFeatures');
        if (featuresEl) featuresEl.innerHTML = trigger.dataset.planDescription || '';

        // The Free package cannot be "upgraded" to — hide the submit button for it.
        // (The popup is only shown to logged-in users; not-logged-in users follow
        // the teaser link to the registration page instead.)
        const submitBtn = form.querySelector('[type="submit"]');
        if (submitBtn) {
            submitBtn.classList.toggle('d-none', trigger.dataset.planIsFree === 'true');
        }

        if (noteEl) {
            const template = trigger.dataset.upgradeNote || noteTemplate;
            noteEl.textContent = template
                .replace(/\{currentPlan\}/g, currentPlanTitle)
                .replace(/\{targetPlan\}/g, targetPlanTitle);
        }

        document.getElementById('upgradeFormPlanId').value = trigger.dataset.planId || '';
        document.getElementById('upgradeFormPlanTitle').value = targetPlanTitle;
        document.getElementById('upgradeFormPlanPrice').value = trigger.dataset.planPrice || '';
        document.getElementById('upgradeFormPlanDuration').value = trigger.dataset.planDuration || '';
    };

    const fillUserData = () => {
        if (typeof window.Auth === 'undefined' && typeof window.Amplify === 'undefined') {
            return;
        }

        const authLib = window.Auth || (window.Amplify && window.Amplify.Auth);
        if (!authLib || typeof authLib.currentUserInfo !== 'function') {
            return;
        }

        authLib
            .currentUserInfo()
            .then((userInfo) => {
                if (!userInfo || !userInfo.attributes) {
                    return;
                }
                const attrs = userInfo.attributes;
                document.getElementById('upgradeFormUserEmail').value = attrs.email || '';
                document.getElementById('upgradeFormUserFirstName').value = attrs.given_name || '';
                document.getElementById('upgradeFormUserName').value = attrs.family_name || '';
                document.getElementById('upgradeFormOrgName').value =
                    attrs['custom:org_name'] || attrs['custom:organization'] || '';
            })
            .catch(() => {
                // Could not retrieve user info — form will be submitted with empty user fields
            });
    };

    const handleTriggerClick = (event) => {
        event.preventDefault();
        const trigger = event.currentTarget;
        fillPlanData(trigger);
        fillUserData();
        openPopup();
    };

    const handleFormSubmit = (event) => {
        event.preventDefault();

        const formData = new FormData(form);
        const submitBtn = form.querySelector('[type="submit"]');
        if (submitBtn) {
            submitBtn.disabled = true;
        }

        fetch(form.action, {
            method: 'POST',
            body: formData,
        })
            .then((response) => response.json())
            .then((data) => {
                if (data.success) {
                    form.classList.add('d-none');
                    successMsg.classList.remove('d-none');
                } else {
                    alert('Es ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.');
                    if (submitBtn) {
                        submitBtn.disabled = false;
                    }
                }
            })
            .catch(() => {
                alert('Es ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.');
                if (submitBtn) {
                    submitBtn.disabled = false;
                }
            });
    };

    const initStateReady = () => {
        const triggers = document.querySelectorAll('.openUpgradePopup');
        triggers.forEach((trigger) => {
            trigger.addEventListener('click', handleTriggerClick);
        });

        overlay.addEventListener('click', closePopup);
        if (closeBtn) {
            closeBtn.addEventListener('click', closePopup);
        }
        if (cancelBtn) {
            cancelBtn.addEventListener('click', closePopup);
        }

        form.addEventListener('submit', handleFormSubmit);
    };

    document.addEventListener('readystatechange', () => {
        if (document.readyState !== 'complete') return;
        initStateReady();
    });
})();
